fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var zlGlobalCartArray = [];
      var zlGlobalCartMap = {};
      var prodsArray = {};
      var removedArray = [];
      if(zlgetCookie("zlCartsArray")){
           var zlCookie = JSON.parse(zlgetCookie("zlCartsArray"));
      }
      data.items.forEach((product)=> {
          var productX = {
             product_id: product.id,
             product_type: product.product_type,
             name: product.product_title,
             brand: product.vendor,
             variant: product.variant_title,
             variant_id: product.variant_id,
             price: product.price,
             quantity : product.quantity,
             url: product.url,
             image_url: product.image,
        };
        prodsArray[product.id] =  { quantity : product.quantity , val : productX };
        zlGlobalCartMap[product.id] = productX;
        zlGlobalCartArray.push(productX);

        if (requestPageType == 'collection' || requestPageType == 'list-collections') {
            productX.category = product.product_title;
            zltCollectionTrack(productX);
        }
      })
      if(zlGlobalCartArray.length == 0){
          document.cookie = "zlCartsArray" +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }else{
          zlsetCookie("zlCartsArray" , JSON.stringify(zlGlobalCartMap) , 326 );
      }
      if(typeof(zlCookie) != "undefined" ){
        if(zlGlobalCartArray.length > 0  && Object.keys(zlCookie).length  > 0  ){
           zlGlobalCartArray.forEach(function(val,ind){
               if(typeof(zlCookie[val.product_id]) === 'undefined')
                zlt.track("Added to Cart", val );
              else if(zlCookie[val.product_id].quantity < val.quantity )
                zlt.track("Added to Cart", val );
              else if(zlCookie[val.product_id].quantity > val.quantity)
                zlt.track("Removed from Cart", val );
           });
          }
        for (var products of  Object.keys(zlCookie))
        {
            if(typeof(zlGlobalCartMap[products]) == "undefined"){
              zlt.track("Removed from Cart", zlCookie[products] );
            }
        }
      }
      if(zlGlobalCartArray.length > 0 && !zlgetCookie("zlCartsArray")){
          zlGlobalCartArray.forEach(function(val,ind){
            zlt.track("Added to Cart", val );
          });
      }

      if (requestPageType == 'cart') {
          zltCartTrack (data.token ,zlGlobalCartArray);
      }

      if (isLoggedIn){
            zltUserTrack();
       }
});


function zltCollectionTrack (product) {
   zlt.track('Product Seen', product);
}

function zltUserTrack () {
  zlt.track('user', {
      user_id: logState.userId,
      email: logState.customerEmail,
      first_name: logState.customerInfo.firstName,
      last_name: logState.customerInfo.lastName,
  });
}

function zltCartTrack (token, zlGlobalCartArray) {
  zlt.track("Cart Viewed", {
      cart_id : token,
      products : zlGlobalCartArray
  });
}
